import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-webinar-fr',
  templateUrl: './webinar-fr.component.html',
  styleUrls: ['./webinar-fr.component.scss'],
})
export class WebinarFrComponent implements OnInit {
  ngOnInit(): void {}

  isDateInPast(dateString: string): boolean {
    const [day, month, year] = dateString.split('.');
    const webinarDate = new Date(`${year}-${month}-${day}`);
    const today = new Date();
    return webinarDate < today;
  }
}
